import { request } from './api.js';

// #50 (PLAN-5): Vertretungen. Das Backend (routes/substitutions.ts) reichert die Liste mit den
// Namen an (absent_name/substitute_name), damit sie ohne zweiten Mitglieder-Lookup lesbar ist.
export interface Substitution {
  substitution_id: string;
  absent_user_id: string;
  absent_name: string | null;
  substitute_user_id: string;
  substitute_name: string | null;
  from_date: string;
  to_date: string;
}

export interface SubstitutionCreateBody {
  absent_user_id: string;
  substitute_user_id: string;
  from_date: string;
  to_date: string;
}

const base = (p: string) => `/v1/projects/${p}`;

export const substitutionsApi = {
  list: (p: string) => request<Substitution[]>(`${base(p)}/substitutions`),
  create: (p: string, body: SubstitutionCreateBody) =>
    request<Substitution>(`${base(p)}/substitutions`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  remove: (p: string, id: string) =>
    request<void>(`${base(p)}/substitutions/${id}`, { method: 'DELETE' }),
};
